import { render, staticRenderFns } from "./Satisfaction.vue?vue&type=template&id=67db6e51&scoped=true&"
import script from "./Satisfaction.vue?vue&type=script&lang=js&"
export * from "./Satisfaction.vue?vue&type=script&lang=js&"
import style0 from "./Satisfaction.vue?vue&type=style&index=0&id=67db6e51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67db6e51",
  null
  
)

export default component.exports